// Vars
const body = document.querySelector('body');
const yirContainer = document.querySelector('.jsYirContainer');
const yirMenu = document.querySelector('.yir-menu');
const navTogglers = document.querySelectorAll('.jsNavToggle');
const navHide = document.querySelectorAll('.jsNavHide');

// Listen for menu toggle clicks
for (var i = 0; i < navTogglers.length; i++) {
	navTogglers[i].addEventListener('click', () => {
		body.classList.toggle('-navOpen')
	});
}
for (var i = 0; i < navHide.length; i++) {
	navHide[i].addEventListener('click', () => {
		body.classList.remove('-navOpen')
	});
}

// Current nav item
const pages = [
	document.querySelector('#yir-cover'),
	document.querySelector('#page-one'),
	document.querySelector('#page-two'),
	document.querySelector('#page-three'),
	document.querySelector('#page-four'),
	document.querySelector('#page-five'),
	document.querySelector('#page-six'),
	document.querySelector('#page-seven'),
	document.querySelector('#page-eight'),
	document.querySelector('#page-nine'),
	document.querySelector('#page-ten'),
	document.querySelector('#fullreport')
];

const navItems = {
	"page-one": yirMenu.querySelector('a[href="#page-one"]'),
	"page-two": yirMenu.querySelector('a[href="#page-two"]'),
	"page-three": yirMenu.querySelector('a[href="#page-three"]'),
	"page-four": yirMenu.querySelector('a[href="#page-four"]'),
	"page-five": yirMenu.querySelector('a[href="#page-five"]'),
	"page-six": yirMenu.querySelector('a[href="#page-six"]'),
	"page-seven": yirMenu.querySelector('a[href="#page-seven"]'),
	"page-eight": yirMenu.querySelector('a[href="#page-eight"]'),
	"page-nine": yirMenu.querySelector('a[href="#page-nine"]'),
	"page-ten": yirMenu.querySelector('a[href="#page-ten"]'),
	"fullreport": yirMenu.querySelector('a[href="#fullreport"]')
}

const observerOptions = {
	root: null,
	rootMargin: '0px',
	threshold: 0.5,
};

function observerCallback(entries, observer) {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			// Indicate on the container which section is current
			body.dataset.currentPage = entry.target.id;

			// Update hash in URL
			history.replaceState(undefined, undefined, '#' + entry.target.id);

			// If the current section has a matching nav item, mark that as current.
			if (navItems[entry.target.id]) {
				const navItem = navItems[entry.target.id];
				navItem.parentElement.classList.add('current');
				Object.values(navItems).forEach((item) => {
					if (item != navItem) {
						item.parentElement.classList.remove('current');
					}
				});
			}
		}
	});
}

const observer = new IntersectionObserver(observerCallback, observerOptions);

// Observe all pages/sections
pages.forEach((page) => observer.observe(page));